/** YYYY-MM-DD, без допуска нормализации несуществующих дат вроде 31 февраля. */
export function validDiaryDate(date) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date))
        return false;
    const parsed = new Date(`${date}T00:00:00Z`);
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date;
}
/** Выбранные местные сутки + текущее местное время; без даты — обычное «сейчас». */
export function entryTimestamp(date, tzOffsetMinutes, now = new Date()) {
    if (!date)
        return now.toISOString();
    if (!validDiaryDate(date))
        throw new Error('Некорректная дата дневника');
    const local = new Date(now.getTime() + tzOffsetMinutes * 60_000);
    const time = local.toISOString().slice(11);
    return new Date(new Date(`${date}T${time}`).getTime() - tzOffsetMinutes * 60_000).toISOString();
}
//# sourceMappingURL=diary-date.js.map